import { Reveal } from "@/lib/motion";
import { Chapter } from "./Chapter";
import { RESEARCH, PROFILE } from "@/data/content";
import { ShieldCheck, ExternalLink } from "lucide-react";

export const Research = () => (
  <section id="research" className="relative z-10 py-24 md:py-32 lg:py-40">
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
      <Chapter num="03" title="Featured research" kicker="Undergraduate study" />

      <Reveal>
        <div className="group grid grid-cols-1 lg:grid-cols-12 border border-[#d2d5ce] hover:border-[#16324f] transition-colors duration-500 bg-[#f5f6f2] overflow-hidden">
          <div className="lg:col-span-4 relative overflow-hidden aspect-[4/3] lg:aspect-auto lg:min-h-[420px] border-b lg:border-b-0 lg:border-r border-[#d2d5ce]">
            <img
              src={PROFILE.research_bg}
              alt="Abstract data network"
              className="w-full h-full object-cover grayscale-[0.2]"
            />
            <div className="absolute inset-0 bg-[#16324f]/20 mix-blend-multiply" />
            <span className="absolute top-4 left-4 font-mono-plex text-[11px] uppercase tracking-[0.16em] text-[#f5f6f2] bg-[#b5423a] px-3 py-1.5">
              Lead author
            </span>
          </div>

          <div className="lg:col-span-8 p-8 md:p-12 lg:p-16 flex flex-col justify-center">
            <h3 className="font-serif-display font-light text-2xl md:text-[34px] leading-tight text-[#16324f] max-w-2xl">
              {RESEARCH.title}
            </h3>
            <p className="mt-6 text-[16px] md:text-[17px] text-[#3a4d5c] leading-relaxed max-w-2xl">
              {RESEARCH.desc}
            </p>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {RESEARCH.tags.map((t) => (
                <span
                  key={t}
                  className="font-mono-plex text-[12.5px] px-3.5 py-1.5 rounded-full border border-[#d2d5ce] text-[#48606f] bg-[#eef0e9]"
                >
                  {t}
                </span>
              ))}
            </div>

            <div className="mt-9 pt-7 border-t border-[#d2d5ce] flex flex-col sm:flex-row sm:items-center gap-4 sm:justify-between">
              <div className="flex items-start gap-3">
                <ShieldCheck size={20} strokeWidth={1.6} className="shrink-0 mt-0.5 text-[#2e7d6b]" />
                <div>
                  <p className="font-mono-plex text-[11px] uppercase tracking-[0.16em] text-[#2e7d6b]">
                    Licensed by NACOSTI
                  </p>
                  <p className="mt-1 text-[14px] text-[#3a4d5c] leading-snug">
                    National Commission for Science, Technology &amp; Innovation, Kenya · Permit No.{" "}
                    <span className="text-[#16324f] font-medium">NACOSTI/P/26/4193073</span> · Valid to July 2027
                  </p>
                </div>
              </div>
              <a
                data-testid="research-licence-link"
                href="/nacosti-research-licence.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="shrink-0 inline-flex items-center gap-2 self-start sm:self-auto border border-[#16324f] text-[#16324f] font-mono-plex text-[11.5px] uppercase tracking-[0.12em] px-5 py-2.5 rounded-full hover:bg-[#16324f] hover:text-[#f5f6f2] transition-colors duration-400"
              >
                <ExternalLink size={13} /> View licence
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
